import { Analytics } from '@cobliteam/analytics';
import { useTranslation } from '@cobliteam/i18n';
import TriggerTemplateModal from '@cobliteam/triggers/src/containers/TriggerLandingPageTemplates/components/TriggerTemplateModal/TriggerTemplateModal';
import useTriggersStore from '@cobliteam/triggers/src/store/useTriggersStore';
import Button from '@cobliteam/ui/components/Button';
import { useEffect } from 'react';

interface AlertStepActionProps {
  fleetId?: string;
  /** Called after the alert is created, to advance to the next step. */
  onCompleted?: () => void;
}

/** One-click alert creation using the "vehicle speed limit" template modal from the triggers module. */
const AlertStepAction = ({ fleetId, onCompleted }: AlertStepActionProps) => {
  const { t } = useTranslation('basic-value-onboarding');
  const setActiveTemplate = useTriggersStore((state) => state.setActiveTemplate);
  const setOpenTemplateModal = useTriggersStore((state) => state.setOpenTemplateModal);
  // The triggers store flips `openSuccessModal` to true once the trigger is created.
  const openSuccessModal = useTriggersStore((state) => state.openSuccessModal);
  const setOpenSuccessModal = useTriggersStore((state) => state.setOpenSuccessModal);

  const handleOpen = () => {
    setActiveTemplate('speed');
    setOpenTemplateModal(true);
    Analytics.track('BasicValueModalItemCreated', { fleetId, feature: 'alerts' });
  };

  // When the alert is created, reset the success flag and advance the guide.
  useEffect(() => {
    if (!openSuccessModal) return;
    setOpenSuccessModal(false);
    onCompleted?.();
  }, [openSuccessModal, setOpenSuccessModal, onCompleted]);

  return (
    <>
      <Button onClick={handleOpen}>{t('features.alerts.cta')}</Button>
      <TriggerTemplateModal />
    </>
  );
};

export default AlertStepAction;
